
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../grpc"

export interface GenerateRequest {
    countryCode: string
    mobileNumber: string
    templateType: TemplateType
}

export interface GenerateResponse {
    done: boolean
    captcha?: string /* 仅供开发测试，正式发布后不会返回。 */
}

export interface CheckRequest {
    countryCode: string
    mobileNumber: string
    captcha: string
}

export interface CheckResponse {
    isCorrect: boolean
}

export enum TemplateType {
    REGISTER = 0, /* 注册模版 */
    GENERAL = 1, /* 一般验证码模版 */
}

export class MobileCaptchaService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    async generate(request: GenerateRequest): Promise<GenerateResponse> {
        const method = "post"
        const path = "/base.captcha.MobileCaptchaService/Generate"
        return await this.call(method, path, request) as GenerateResponse
    }
    
    async check(request: CheckRequest): Promise<CheckResponse> {
        const method = "post"
        const path = "/base.captcha.MobileCaptchaService/Check"
        return await this.call(method, path, request) as CheckResponse
    }
    
}
